export const useModalRouter = () => {
  const route = useRoute();

  const isModal = computed(() => {
    return route.hash.indexOf('#/modal/') === 0;
  });
  const hashModal = computed(() => {
    if (!isModal.value) return '';
    return route.hash.replace('#/modal/', '');
  });

  const hashModalIds = computed(() => {
    return hashModal.value.split('/');
  });

  return {
    hashModalIds,
    hashModal,
    isModal,
  };
};
